import { LogoRemondisBlack } from 'assets/logotype';
import ImageIcon from 'components/Icon/ImageIcon';
import NotFound from 'pages/notFound';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from 'styles/theme';

const REMONDIS_CONTACT = {
  email: 'kundservice@remondis.se',
  phone: '0771-545 000',
  alt: 'Remondis logo',
};

const Thanks = () => {
  const location = useLocation();
  const state = location.state as { from?: string; landingSlug?: string } | null;

  if (!state || state.from !== '/') {
    return <NotFound errorMessage="You can't access thanks outside root." />;
  }

  return (
    <Wrapper>
      <ThanksCard>
        <Heading>Tack för er förfrågan!</Heading>
        <Subheading>En sammanställning av er offert kommer via e-post.</Subheading>
      </ThanksCard>

      <CompanyWrapper>
        <Brand>
          <ImageIcon height={48} src={LogoRemondisBlack} alt={REMONDIS_CONTACT.alt} />
          <BrandDetails>
            <Email>{REMONDIS_CONTACT.email}</Email>
            <Phone>{REMONDIS_CONTACT.phone}</Phone>
          </BrandDetails>
        </Brand>
      </CompanyWrapper>
    </Wrapper>
  );
};

export default Thanks;

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3rem;
  padding: 2rem;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
    gap: 2rem;
    height: 100%;
  }
`;

const ThanksCard = styled.div`
  width: 100%;
  max-width: 945px;
  min-height: 479px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 40px;
  background-color: ${theme.colors.content_background};
  padding: 2rem;

  @media (max-width: 768px) {
    max-width: 90%;
    padding: 1.5rem;
  }
`;

const Heading = styled.h1`
  font-family: var(--secondary-font);
  font-size: 3rem;
  font-weight: 400;
  color: #000000;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Subheading = styled.p`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.4);
  line-height: 125%;
  letter-spacing: 0.02px;
  font-size: 1rem;
  margin: 12px 0 0;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const CompanyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 3rem;
  }
`;

const Brand = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
`;

const BrandDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0 0;
`;

const Email = styled.span`
  line-height: 1.5;
  font-weight: bold;
`;

const Phone = styled.span`
  line-height: 1.5;
  font-weight: 400;
`;
